export enum ETrackerEvents {
    // 登录埋点
    LOGIN_SHOW = 'login_show',
    LOGIN_CLICK = 'login_click',
    LOGIN_RESULT = 'login_result',

    /** --全局-- */
    /** 页面打开 */
    H5_OPEN = 'h5_open',
    /** 页面曝光 */
    PAGE_EXPOSURE = 'page_exposure',
    /** 页面数据加载完成 */
    PAGE_DATA_LOADED = 'page_data_loaded',
    /** 标签页点击 */
    TAB_CLICK = 'tab_click',
    /** --全局-- */

    /** --推荐-- */
    /** 书籍曝光 */
    BOOK_SHOW = 'book_show',
    /** 书籍点击 */
    BOOK_CLICK = 'book_click',
    /** --推荐-- */

    /** --个人中心-- */
    PROFILE_CLICK = 'profile_click',

    // 充值
    RECHARGE_PAGE_SHOW = 'recharge_page_show',
    RECHARGE_PAGE_CLICK = 'recharge_page_click',
    RECHARGE_PAGE_STAY = 'recharge_page_stay',
    RECHARGE_PAGE_RESULT = 'recharge_page_result',
    ORDER_CREATE = 'order_create',
    GATEWAY_SHOW = 'gateway_show',
    LANDING_TIMESTAMP = 'landing_timestamp',

    /** --通用弹窗-- */
    /** 弹窗条件满足、开始唤起 */
    POP_UP_TRIGGER = 'pop_up_trigger',
    /** 弹窗渲染完成、用户可视 */
    POP_UP_SHOW = 'pop_up_show',
    /** 弹窗内点击行为 */
    POP_UP_CLICK = 'pop_up_click',

    /** 落地页染色条件满足 */
    DYEING_DID = 'dyeing_did',
    /** 用户 HTTP Referer（设备维度仅上报一次） */
    USER_REFERER = 'user_referer',
}
